import { Tag } from 'antd'
import React from 'react'

function UITag({ name, ...props }) {
    return <Tag {...props}> {name} </Tag>
}

export default UITag
